import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Pricing Penguin',
  url: 'https://www.pricingpenguin.co.uk',
  logo: 'https://www.pricingpenguin.co.uk/logo.png',
  description: 'AI-powered home improvement quoting platform connecting UK homeowners with trusted tradespeople.',
  sameAs: [
    'https://www.instagram.com/pricingpenguin/',
    'https://www.tiktok.com/@pricingpenguin',
    'https://www.linkedin.com/company/pricing-penguin-ltd/',
    'https://www.facebook.com/people/Pricing-Penguin/61575007326564/'
  ]
};

const OrganizationSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  </Helmet>
);

export default OrganizationSchema;
